export const DEFAULT_ASSET_EVENT_STALE_TIME = 60 * 60 * 1000; // 1 hour
